// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-chip-group.dense-value .v-slide-group__content{padding-bottom:0!important;padding-top:0!important}.item-value-color-pin{border:2px solid #ccc;border-radius:50%;display:inline-block;height:24px;left:2px;position:absolute;top:8px;width:24px}.item-value-detail-textarea{white-space:pre-line;word-wrap:break-word}.item-value-detail p:last-child{margin-bottom:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
